export class MapUtils {
  private constructor() {}

  /**
   * @param a - gets modified in place
   * @param b
   */
  public static mergeMapsInPlace<TKey, TValue>(a: Map<TKey, TValue>, b: Map<TKey, TValue>, valueMerger = (valueA: TValue, valueB: TValue) => valueB): void {
    b.forEach((value, key) => {
      if (a.has(key)) {
        const mergedValue = valueMerger(a.get(key) as TValue, value);
        a.set(key, mergedValue);
      } else {
        a.set(key, value);
      }
    });
  }
}